import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class SiteText {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    _distance: number;

    get distance(): number { return this._distance; }

    set distance(value: number) {
      this._distance = value;
    }

    minVisibleDistance: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch * 0.25;

    index: number;

    linePartner: marietta.webcad.item.parts.SiteLine;

    parent: marietta.webcad.item.Site;

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetNode: Element, id: number) {
      this.index = id;

      // ラインの作成
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      viewObj.setAttribute('id', `site_line_text_${id}`);
      viewObj.setAttribute('fill', '#000000');
      viewObj.textContent = '0mm';
      this.spt = new SVGSprite(viewObj);
      targetNode.appendChild(viewObj);

      // アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mouseout', this.hideHighlight);
        this.viewObj.addEventListener('mouseover', this.showHighlight);
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (!this.firstDot || !this.secondDot) return;
      // const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
      this.distance = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(this.firstDot, this.secondDot));
      const num = marietta.webcad.util.WebCADUtil.sepThreeDigit(Math.round(this.distance));
      this.viewObj.textContent = `${num}mm`;
      // const bound = this.viewObj.getBoundingClientRect();

      // this.viewObj.setAttribute("x", (centerPoint.x - bound.width/2).toString() );
      // this.viewObj.setAttribute("y", (centerPoint.y + bound.height/2).toString() );

      this.spt.visible = this.minVisibleDistance < this.distance;
      this.spt.update();
      this.updateTranslate();
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }

    /**
     * ハイライト非表示
     */
    hideHighlight = () => {
      if (!marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
        return;
      }

      if (!this.linePartner) return;
      this.linePartner.highlight(false);
    }

    /**
     * ハイライト表示
     */
    showHighlight = () => {
      if (!marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
        return;
      }

      if (!this.linePartner) return;
      if (this.linePartner.locked) return;
      this.linePartner.highlight(true);
    }

    /**
     * マウスダウンされた
     */
    onMouseDownMe = () => {
      if (!marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
        return;
      }

      this.onClickSiteText();
    }

    /**
     * 敷地の長さテキストがクリックされた
     */
    onClickSiteText() {
      if (this.linePartner.locked) return;
      const { index } = this as marietta.webcad.item.parts.SiteText;

      // 道路入力ダイアログの表示
      const tarDialog: marietta.webcad.view.dialog.RoadSetting = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoadSetting) as marietta.webcad.view.dialog.RoadSetting;
      tarDialog.index = index - 1;
      tarDialog.targetSite = (this as marietta.webcad.item.parts.SiteText).parent;
    }

    updateTranslate() {
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;
      /* if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
            sc *= 2;
        } */
      if (!this.firstDot || !this.secondDot) return;
      const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
      const bound = this.viewObj.getBoundingClientRect();
      const x = (centerPoint.x - (bound.width / 2) * sc);
      const y = (centerPoint.y + (bound.height / 2) * sc);
      const transformMatrix = `matrix(${sc},0,0,${sc},${x},${y})`;
      this.spt.element.setAttribute('transform', transformMatrix);
    }
}
